import { Badge } from "./ui/badge";
import { PRIORITY_STYLES, ROLE_STYLES, STATUS_STYLES, useLabels } from "../lib/constants";

export function StatusBadge({ status, testid }) {
  const L = useLabels();
  return (
    <Badge variant="outline" data-testid={testid}
      className={`whitespace-nowrap border text-xs font-medium ${STATUS_STYLES[status] || "bg-slate-100 text-slate-600 border-slate-200"}`}>
      {L.status[status] || status}
    </Badge>
  );
}

export function PriorityBadge({ priority, testid }) {
  const L = useLabels();
  return (
    <Badge variant="outline" data-testid={testid}
      className={`whitespace-nowrap border text-xs font-medium ${PRIORITY_STYLES[priority] || "bg-slate-100 text-slate-600 border-slate-200"}`}>
      {L.priority[priority] || priority}
    </Badge>
  );
}

export function CompanyBadge({ company, testid }) {
  const L = useLabels();
  return (
    <Badge variant="outline" data-testid={testid}
      className="whitespace-nowrap border border-delta-limeBorder bg-delta-limeLight text-xs font-medium text-[#5c7023]">
      {L.company[company] || company}
    </Badge>
  );
}

export function TypeBadge({ type, testid }) {
  const L = useLabels();
  return (
    <Badge variant="outline" data-testid={testid}
      className="whitespace-nowrap border border-indigo-200 bg-indigo-50 text-xs font-medium text-indigo-800">
      {L.type[type] || type}
    </Badge>
  );
}

export function RoleBadge({ role, testid }) {
  const L = useLabels();
  return (
    <Badge variant="outline" data-testid={testid}
      className={`whitespace-nowrap border text-xs font-medium ${ROLE_STYLES[role] || "bg-slate-100 text-slate-600 border-slate-200"}`}>
      {L.role[role] || role}
    </Badge>
  );
}
